import { ArcadePopup } from "../components/ArcadePopup";
import { CONST } from "../CONST";

export class MenuScene extends Phaser.Scene {
    private clouds !: Phaser.GameObjects.Group;
    private cloudMovementSpeed = 25;

    private arcadePopup !: ArcadePopup;

    private buttons !: MenuButton[];
    private soundButton !: Phaser.GameObjects.Image;

    private isArcadeEnabled : boolean = true;


    constructor(){
        super({
            key: CONST.SCENES.MENU,
        })
    }

    init(){
        this.registry.set(CONST.REGISTRY.SKIPUSED, false);
    }

    preload(){}

    create(){      
        this.getRemoteConfig();
        
        this.createClouds();

        this.createSoundButton();

        this.add.image(0,0, CONST.MENU.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(0,480, CONST.MENU.NATURE).setOrigin(0, 1).setDepth(2);

        this.add.image(335, 272, CONST.MENU.CHARACTER).setDepth(3);

        this.add.image(577, 160, CONST.MENU.TITLE_TEXT).setDepth(3);
    
        this.buttons = [];

        let playButton = new MenuButton(this, 577, 287, CONST.BUTTONS.RED, "PLAY", () => {this.scene.start(CONST.SCENES.BIRTH);});
        this.buttons.push(playButton);

        if (this.canContinueGame() && this.remoteConf.getConfig("hBe") === "true"){
            let continueButton = new MenuButton(this, 577, 445, CONST.BUTTONS.ORANGE, "CONTINUE", () => { this.scene.start(this.getProgressScene());}, 30);
            this.buttons.push(continueButton);
        }

        if (this.isArcadeEnabled){
            this.arcadePopup = new ArcadePopup(this);

            let arcadeButton = new MenuButton(this, 577, 366, CONST.BUTTONS.PURPLE, "ARCADE"
            , () => {
                this.arcadePopup.open();
                this.setButtonsInteractive(false);
            }, 35);
            this.buttons.push(arcadeButton);


            // if (this.arcadePopup.hasNewArcadeGames()){
            //     //add new tag
            // let tag = this.add.image(68, -22, CONST.ARCADE_SCREEN.NEW).setDepth(5); //642, 341

            //     this.tweens.add({
            //         targets: tag,
            //         angle: "+=5",
            //         duration: 500,
            //         hold: 2500,
            //         repeat: -1,
            //         ease: (t: number) => {return this.wiggle(t, 1, 1)},
            //     });
            // arcadeButton.add(tag);

            // }

            this.openArcade();
        }

        let buttonPos = {startX: 577, startY: 287, changeY: 65};
        for (let i = 0; i < this.buttons.length; i++){
            this.buttons[i].setPosition(buttonPos.startX, buttonPos.startY + i * buttonPos.changeY);
        }
    }

    private canContinueGame(){
        //has progress key, and it does not equal credits
       let progress = this.storagePlugin.getItem(CONST.STORAGE_KEYS.PROGRESS);
       return progress && progress != CONST.SCENES.DIE && progress != CONST.SCENES.CREDITS;
    }

    private getProgressScene(){
        return this.storagePlugin.getItem(CONST.STORAGE_KEYS.PROGRESS);
    }

    private getRemoteConfig(){
       this.isArcadeEnabled = this.remoteConf.getConfig("aE") === "true";
    }


    private wiggle(aProgress: number, aPeriod1: number, aPeriod2: number): number {
        var current1: number = aProgress * Math.PI * 2 * aPeriod1;
        var current2: number = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);

        return Math.sin(current1) * Math.cos(current2);
    }

    protected openArcade(){
        var shouldOpen = this.storagePlugin.getItem("openArcadePopup", "");
        if (shouldOpen && parseInt(shouldOpen) == 1){
            this.arcadePopup.open();
            this.setButtonsInteractive(false);
            this.storagePlugin.setItem("openArcadePopup", "0");
        }
    }

    public setButtonsInteractive(interactive: boolean){
        this.buttons.forEach(button => {button.overrideInteractive(interactive)});
    }

    createClouds(){
        var cloudArr = [];

        for (var i = 0; i < 3; i++){
            var c = this.add.image(-this.game.renderer.width * (i - 1),
                                    20,
                                    CONST.MENU.CLOUDS)
                            .setOrigin(0, 0)   
                            .setDepth(1);
            cloudArr.push(c);
        }

        this.clouds = this.add.group(cloudArr);
    }

    createSoundButton(){
        this.soundButton = this.add.image(30, this.renderer.height - 30, this.audioPlugin.isAudioEnabled() ? CONST.BUTTONS.SOUND_ON : CONST.BUTTONS.SOUND_OFF)
                                .setDepth(3)
                                .setInteractive({ useHandCursor: true })
                                .setScale(0.7);

        this.soundButton.on("pointerup", ()=>{
            let audioEnabled = this.audioPlugin.toggleAudioEnabled();
            this.soundButton.setTexture(audioEnabled ? CONST.BUTTONS.SOUND_ON : CONST.BUTTONS.SOUND_OFF);
        });  
    }


    update(time: number, delta: number){
        this.updateClouds();
    }

    private updateClouds(){
        if (!this.clouds) return;

        this.clouds.getChildren().forEach(child => {
            //move child
            //@ts-ignore
            child.x += this.cloudMovementSpeed * this.game.loop.delta/1000.0;


            //teleport if out of bounds
            //@ts-ignore
            if (child.x >= this.game.renderer.width){
                //@ts-ignore
                child.x -= 2*this.game.renderer.width;
            }
        });
    }
}

class MenuButton extends Phaser.GameObjects.Container {
    private buttonTween!: Phaser.Tweens.Tween;
    private bgImage: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number,  y: number, bgTexture: string, buttonText: string, onClick: () => void, fontSize = 40) {
        super(scene, x, y);

       //create bg, create text
       this.bgImage = this.scene.add.image(0, 0, bgTexture);
       let text = this.scene.add.bitmapText(0, 0, CONST.FONT.ATLAS, buttonText, fontSize).setOrigin(0.5, 0.4);
        this.add([this.bgImage, text]);

        scene.add.existing(this);

        this.setDepth(3);

        this.bgImage.on("pointerup", () => {
            onClick();
        });

        this.bgImage.on("pointerover", () => {
            this.animateButton(true);
        });

        this.bgImage.on("pointerout", () => {
            this.animateButton(false);
        });

        this.overrideInteractive(true);
    }

    animateButton(animIn: boolean){
        if (this.buttonTween){
            this.buttonTween.stop();
        }

        this.buttonTween = this.scene.tweens.add({
            targets: this,
            scaleX: animIn ? 1.05 : 1,
            scaleY: animIn ? 1.05 : 1,
            ease: "Quad.easeInOut",
            duration: 75,
            repeat: 0,
            yoyo: false,
        })
    }

    overrideInteractive(interactive: boolean){
        if (interactive){
            this.bgImage.setInteractive({useHandCursor: true, pixelPerfect: true});
        } else {
            this.bgImage.disableInteractive();
        }
    }

    
}